import React from 'react'
import ChecklistTemplateEditForm from 'pages/app/checklists/ChecklistTemplateEditForm'
import WhenDeviceNotAuthorized from 'support/conditionals/WhenDeviceNotAuthorized'
import AdminPage from 'pages/app/AdminPage'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as UI from 'ui'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Link, useRouter } from '@morningtrain/react-navigation'
import * as Icons from 'ui/icons'
import { get } from 'mobx'
import RedirectToEditOnCreatePipeline from 'support/pipelines/RedirectToEditOnCreatePipeline'

export default function CreateTemplate () {
  const router = useRouter()

  const parameters = (router && router.current) ? router.current.parameters : {}

  const value = get(parameters, 'template_id')

  return (
    <WhenDeviceNotAuthorized>
      <AdminPage>
        <Translator namespace='checklists'>
          <UI.PageHeader title={<TranslatedTitle name='checklist_templates'/>}>
            <UI.ButtonWrap>
              <Link route='app.checklists'>
                <UI.Button>
                  <Icons.ArrowLeft className='mr-2'/>
                  <span><Translation name='checklists.actions.back_to_overview'/></span>
                </UI.Button>
              </Link>
            </UI.ButtonWrap>
          </UI.PageHeader>
          <ChecklistTemplateEditForm checklistId={value}>
            <RedirectToEditOnCreatePipeline routeName={'app.create_checklist_template'}/>
          </ChecklistTemplateEditForm>
        </Translator>
      </AdminPage>
    </WhenDeviceNotAuthorized>
  )
}

